// istanbul ignore file
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isMobileBreakpoint } from '../breakpointHelper';

class BreakpointProvider extends PureComponent {
  constructor(props) {
    super(props);

    const {
      defaultBreakpoint = 'xsmall',
      setCurrentBreakpoint,
      setBreakpoints,
      setIsMobile,
      breakpoints,
      mobileConditionBreakpointsArray,
    } = this.props;

    // Call these here so that currentBreakpoint set to defaultBreakpoint
    // in the following scenarios:
    // - during server side render
    // - during first render on client
    setBreakpoints(breakpoints);
    setCurrentBreakpoint(defaultBreakpoint);
    setIsMobile(isMobileBreakpoint({ name: defaultBreakpoint, mobileConditionBreakpointsArray }));
  }

  componentDidMount() {
    const {
      listenForBreakpointChanges,
      mobileConditionBreakpointsArray,
    } = this.props;

    // call this here so that a re-render is caused if the
    // actual breakpoint is different from the defaultBreakpoint
    listenForBreakpointChanges({ mobileConditionBreakpointsArray });
  }

  render() {
    return this.props.children;
  }
}

BreakpointProvider.propTypes = {
  defaultBreakpoint: PropTypes.string,
  children: PropTypes.node.isRequired,
  breakpoints: PropTypes.objectOf(PropTypes.string).isRequired,
  setBreakpoints: PropTypes.func.isRequired,
  setCurrentBreakpoint: PropTypes.func.isRequired,
  setIsMobile: PropTypes.func.isRequired,
  listenForBreakpointChanges: PropTypes.func.isRequired,
  mobileConditionBreakpointsArray: PropTypes.arrayOf(PropTypes.string),
};

export default BreakpointProvider;
